<template>
  <div>
    <div class="container-fluid">
      <legend>Учет и печать накладных</legend>
      <list-by-time-and-courier-id
        v-if="$route.query.time && $route.query.panelUserId"
        :allow-printing="true"
        :customer-id="$route.query.customerId"
        :panel-user-id="$route.query.panelUserId"
        :time="$route.query.time"
      ></list-by-time-and-courier-id>
      <div v-else>
        <table class="table table-bordered table-hover table-sm" v-if="rerender">
          <tbody>
            <tr v-for="(item, index) in unCompleteWaybills">
              <td width="50">
                {{ index + 1 }}
              </td>
              <td width="200">
                <router-link
                  :to="{ name: 'waybills', query: { time: item.DeliveryDate, panelUserId: item.PanelUserId, customerId: item.CustomerId }}">
                  {{ item.DeliveryDate }}
                </router-link>
              </td>
              <td width="200">
                {{ item.PanelUser.Login }}
              </td>
              <td width="300">
                {{ item.PanelUser.Lname }} {{ item.PanelUser.Fname }} {{ item.PanelUser.Mname }}
              </td>
              <td>{{ item.Reception }}</td>
              <td width="100">
                {{ item.OrderCount }}
              </td>
              <td width="24">
                <input type="checkbox" v-model="item.isComplete" @change="wayBillChange($event, item)">
              </td>
            </tr>
          </tbody>
        </table>
        <h5>Закрытые накладные</h5>
        <table class="table table-bordered table-hover table-sm">
          <tbody>
            <tr v-for="(item, index) in completeWaybills">
              <td width="50">
                {{ index + 1 }}
              </td>
              <td width="200">
                <router-link
                  :to="{ name: 'waybills', query: { time: item.DeliveryDate, panelUserId: item.PanelUserId, customerId: item.CustomerId}}">
                  {{ item.DeliveryDate }}
                </router-link>
              </td>
              <td width="200">
                {{ item.PanelUser.Login }}
              </td>
              <td width="300">
                {{ item.PanelUser.Lname }} {{ item.PanelUser.Fname }} {{ item.PanelUser.Mname }}
              </td>
              <td>{{ item.Reception }}</td>
              <td width="100">
                {{ item.OrderCount }}
              </td>
              <td width="24">
                <input type="checkbox" v-model="item.isComplete" @change="wayBillChange($event, item)">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import ListByTimeAndCourierId from '@/admin/modules/Waybills/_components/ListByTimeAndCourierId.vue';
import api from '@/admin/modules/Waybills/api';
import { post } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;


export default {
  components: {
    ListByTimeAndCourierId,
  },
  data() {
    return {
      list: [],
      waybills: [],
      rerender: true,
    };
  },
  created() {
    this.fetchList();
  },
  computed: {
    completeWaybills() {
      if (!this.list) {
        return [];
      }

      return _.filter(this.list, { isComplete: true });
    },
    unCompleteWaybills() {
      if (!this.list) {
        return [];
      }

      return _.filter(this.list, { isComplete: false });
    },
    // groupedLists() {
    //   const data = {
    //     delivered: [],
    //     nonDelivered: [],
    //   };
    //   if (this.list) {
    //     _.each(this.list, (l) => {
    //       if (!this.waybillIsComplete(l)) {
    //         data.delivered.push(l);
    //       } else {
    //         data.nonDelivered.push(l);
    //       }
    //     });
    //   }
    //   return data;
    // },
  },
  methods: {
    waybillIsComplete(item) {
      let ts = Date.parse(item.DeliveryDate);
      ts /= 1000;
      const is = this.waybills.indexOf(
        `${ts}${item.PanelUserId}${item.CustomerId}`,
      ) !== -1;
      return is;
    },
    async wayBillChange($event, item) {
      this.rerender = false;
      if ($event.target.checked) {
        await post(`${url}/check-waybill`, { item });
        this.$set(item, 'isComplete', true);
        // $event.target.checked = true;
      } else {
        await post(`${url}/uncheck-waybill`, { item });
        this.$set(item, 'isComplete', false);
        // $event.target.checked = false;
      }

      await this.$nextTick(() => {
        this.rerender = true;
      });

      if ($event.target.checked) {
        $event.target.checked = false;
      } else {
        $event.target.checked = true;
      }
    },
    async fetchList() {
      const { data } = await api.fetchDebtByTourId();
      // this.list = data.deliveries;
      this.waybills = data.waybills;
      this.list = _.map(data.deliveries,
        wb => Object.assign(wb, { isComplete: this.waybillIsComplete(wb) }));
    },
  },
};
</script>
